import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';


const json = {

  1: { // Exercise num
    unit: 'Unit 4',
    id: 'WB3-U4-P28-E1',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 4,
    exerciseKey: 'img/FriendsPlus/Page28/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page28/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page28/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page28/E1/3.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page28/E1/4.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page28/E1/5.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page28/E1/6.jpg', input: 4, isCorrect: true },
        { url: 'img/FriendsPlus/Page28/E1/7.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page28/E1/8.jpg' },
      ],

    ]
  },
  2: { // Exercise num
    unit: 'Unit 4',
    id: 'WB3-U4-P28-E2',
    audio: '',
    video: '',
    checkUppercase: true,
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page28/E2/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page28/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page28/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page28/E2/3.jpg', input: true, answer: "music" },
        { url: 'img/FriendsPlus/Page28/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page28/E2/5.jpg', input: true, answer: "P.E." },
        { url: 'img/FriendsPlus/Page28/E2/6.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page28/E2/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page28/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page28/E2/9.jpg', input: true, answer: "English" },
        { url: 'img/FriendsPlus/Page28/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page28/E2/11.jpg', input: true, answer: "math" },
        { url: 'img/FriendsPlus/Page28/E2/12.jpg' },
      ],


    ]
  },
  3: { // Exercise num
    unit: 'Unit 4',
    id: 'WB3-U4-P28-E3',
    audio: '',
    video: '',
    checkUppercase: true,
    component: D1,
    fontSize: 23,
    exerciseKey: 'img/FriendsPlus/Page28/E3/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page28/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page28/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page28/E3/3.jpg', input: true, answer: "I have math on Friday." },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page28/E3/4.jpg' },
        { url: 'img/FriendsPlus/Page28/E3/5.jpg', input: true, answer: "Do you have art on Wednesday?" },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page28/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page28/E3/7.jpg', input: true, answer: "I have P.E. on Thursday." },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page28/E3/8.jpg' },
        { url: 'img/FriendsPlus/Page28/E3/9.jpg', input: true, answer: "When do you have English?" },
      ],


    ]
  },



}

export default json;